import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/goalsSagas";
import MonthPicker from "../../../components/reactMonthPicker/reactMonthPicker";

const DatePicker = () => {
  const dispatch = useDispatch();
  const { calendarStartDate, calendarEndDate } = useSelector((state) => state.goals.currentUser);
  const date = useSelector((state) => state.goals.date);

  return (
    <MonthPicker
      startDate={date}
      calendarStartDate={calendarStartDate}
      calendarEndDate={calendarEndDate}
      single
      updateDates={(date) => dispatch(actionCreators.updateDate(date))}
    />
  );
};

export default DatePicker;
